import React from 'react';
import { PrivateStackParamList } from '../../../navigationApp/types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import CommonHeader from '@app/sharedComponents/Header/Header';

type HeaderProps = {
    navigation: NativeStackNavigationProp<PrivateStackParamList>;
    routeName: string;
    isEnhancementApplicationInProgress: boolean;
};

const Header: React.FC<HeaderProps> = ({ navigation, routeName,isEnhancementApplicationInProgress = false }) => {
    return (
        <CommonHeader
            label='Check limit'
            navigation={navigation}
            //@ts-expect-error
            pageName={routeName}
            customGoBackAction={isEnhancementApplicationInProgress ? () => navigation.goBack() : undefined}
        />
    );
};

export default Header; 